"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasMarketingContactsWriteScopeSelector = exports.isMarketingContactsSKUSelector = exports.marketingContactsOnRenewalSelector = exports.isInMCBetaSelector = void 0;

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _UnitTypes = require("pricing-pages-unified-ui/constants/UnitTypes");

var _Scopes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/Scopes"));

var _ScopeSelectors = require("pricing-pages-unified-ui/selectors/ScopeSelectors");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _CountrySelectors = require("pricing-pages-unified-ui/selectors/CountrySelectors");

var _PublicFeatureFlagSelectors = require("pricing-pages-unified-ui/selectors/PublicFeatureFlagSelectors");

var _PublicFeatureFlags = require("pricing-pages-unified-ui/constants/PublicFeatureFlags");

var isInMCBetaSelector = function isInMCBetaSelector(state) {
  var override = localStorage.getItem('CBX:MarketingContactsBeta');

  if (['true', 'false'].includes(override)) {
    return override === 'true';
  } // In-app pricing page


  if ((0, _ConfigSelectors.isAppAuthSelector)(state)) {
    var marketingContacts = state.marketingContacts;
    if (!marketingContacts) return false;
    return marketingContacts.isInMCBeta;
  } // Public pricing page


  var publicFlagEnabled = (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_JUNE_2_LAUNCH);
  var isInANZ = (0, _CountrySelectors.isInANZSelector)(state);
  return publicFlagEnabled && isInANZ;
};

exports.isInMCBetaSelector = isInMCBetaSelector;

var marketingContactsOnRenewalSelector = function marketingContactsOnRenewalSelector(state) {
  var marketingContacts = state.marketingContacts;
  if (!marketingContacts) return null;
  return marketingContacts.onRenewal;
};

exports.marketingContactsOnRenewalSelector = marketingContactsOnRenewalSelector;

var isMarketingContactsSKUSelector = function isMarketingContactsSKUSelector(state, merchId) {
  var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  if (!merchandiseMap || !merchandiseMap[merchId]) return null;
  var _merchandiseMap$merch = merchandiseMap[merchId],
      additionalUnitMerchId = _merchandiseMap$merch.additionalUnitMerchId,
      units = _merchandiseMap$merch.units;

  if (units) {
    return units === _UnitTypes.MARKETING_CONTACT;
  }

  if (!merchandiseMap[additionalUnitMerchId]) return null;
  return merchandiseMap[additionalUnitMerchId].units === _UnitTypes.MARKETING_CONTACT;
};

exports.isMarketingContactsSKUSelector = isMarketingContactsSKUSelector;

var hasMarketingContactsWriteScopeSelector = function hasMarketingContactsWriteScopeSelector(state) {
  return (0, _ScopeSelectors.hasScopeSelector)(state, _Scopes.default.MARKETABLE_CONTACTS_WRITE);
};

exports.hasMarketingContactsWriteScopeSelector = hasMarketingContactsWriteScopeSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/MarketingContactsSelectors.js
// module id = 29
// module chunks = 5 6 7